import type React from 'react';

import IconButton from 'components/partials/button/icon-button';
import { ChartFrame } from 'components/partials/charts/shared/chart-frame';
import Icons from 'assets/icons';
import classNames from 'classnames';

export type ChartViewMode = 'chart' | 'table';

interface ChartPartFrameProps {
  title?: string;
  subtitle?: string;
  viewMode: ChartViewMode;
  onViewModeChange: (viewMode: ChartViewMode) => void;
  children: React.ReactNode;
}

const activeButtonClass =
  'bg-navy-800 text-white hover:!bg-navy-900 hover:!text-white';

const ChartPartFrame = ({
  title,
  subtitle,
  viewMode,
  onViewModeChange,
  children,
}: ChartPartFrameProps): React.JSX.Element => (
  <ChartFrame
    title={title}
    subtitle={subtitle}
    className="w-full"
    headerActions={
      <div
        role="group"
        aria-label="Chart display mode"
        className="inline-flex items-center gap-0.5 rounded-lg border border-navy-200 bg-white p-1"
      >
        <IconButton
          variant="neutral-text"
          size="sm"
          icon={<Icons.BarChart />}
          aria-label="Chart view"
          aria-pressed={viewMode === 'chart'}
          onClick={() => onViewModeChange('chart')}
          className={classNames(viewMode === 'chart' && activeButtonClass)}
        />
        <IconButton
          variant="neutral-text"
          size="sm"
          icon={<Icons.Table />}
          aria-label="Table view"
          aria-pressed={viewMode === 'table'}
          onClick={() => onViewModeChange('table')}
          className={classNames(viewMode === 'table' && activeButtonClass)}
        />
      </div>
    }
  >
    {children}
  </ChartFrame>
);

export default ChartPartFrame;
